// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'team-member-benefit.page.title': 'Benefits',
    'team-member-benefit.page.archive.title': 'Archived Benefits',
    'team-member-benefit.page.search_results': 'Search Results',
    'team-member-benefit.page.create.title': 'Create New Benefit',
    'team-member-benefit.page.search.title': 'Find Benefits',
    'team-member-benefit.page.edit.title': 'Edit Benefit',
    'team-member-benefit.page.view.title': 'Benefit',
    'team-member-benefit.page.all': 'All',

    'team-member-benefit.button.cancel': 'Cancel',
    'team-member-benefit.button.select': 'Select',
    'team-member-benefit.button.find': 'Find Benefits',
    'team-member-benefit.button.search': 'Apply',
    'team-member-benefit.button.create': 'Save Benefit',
    'team-member-benefit.button.new': 'New Benefit',
    'team-member-benefit.button.save': 'Save Changes',
    'team-member-benefit.button.archive': 'Archive',
    'team-member-benefit.button.delete': 'Permanently Delete',
    'team-member-benefit.button.edit': 'Edit',
    'team-member-benefit.button.restore': 'Restore',
    'team-member-benefit.button.reset': 'Reset',

    'team-member-benefit.placeholder.search': 'Search benefits',

    'team-member-benefit.link.create_first_team_member_benefit': 'Click here to create your first benefit',
    'team-member-benefit.link.team_member_benefits': ' Return to Benefits',
    'team-member-benefit.link.archive': 'Archived Benefits',
    'team-member-benefit.link.retry': 'Click here to retry',

    'team-member-benefit.checkbox.all': 'Check All',
    'team-member-benefit.checkbox.actions_label': 'with selected',

    'team-member-benefit.label.team_member_name': 'Team Member',

    'team-member-benefit.label.from__from_date': 'From from date',
    'team-member-benefit.label.to__from_date': 'To from date',
    'team-member-benefit.label.from_date': 'From Date',

    'team-member-benefit.label.from__thru_date': 'From thru date',
    'team-member-benefit.label.to__thru_date': 'To thru date',
    'team-member-benefit.label.thru_date': 'Thru Date',

    'team-member-benefit.label.payroll_benefit_type_name': 'Payroll Benefit Type',

    'team-member-benefit.label.payslip_label': 'Payslip Label',

    'team-member-benefit.label.is_taxable': 'Is Taxable',

    'team-member-benefit.label.memo': 'Memo',

    'team-member-benefit.label.currency_name': 'Currency',

    'team-member-benefit.label.from__currency_amount_in_cents': 'From Amount',
    'team-member-benefit.label.to__currency_amount_in_cents': 'To Amount',
    'team-member-benefit.label.currency_amount_in_cents': 'Amount',

    'team-member-benefit.label.from__base_amount_in_cents': 'From base amount in cents',
    'team-member-benefit.label.to__base_amount_in_cents': 'To base amount in cents',
    'team-member-benefit.label.base_amount_in_cents': 'Base Amount In Cents',

    'team-member-benefit.label.from__system_amount_in_cents': 'From system amount in cents',
    'team-member-benefit.label.to__system_amount_in_cents': 'To system amount in cents',
    'team-member-benefit.label.system_amount_in_cents': 'System Amount In Cents',

    'team-member-benefit.label.from__created_at': 'From created at',
    'team-member-benefit.label.to__created_at': 'To created at',
    'team-member-benefit.label.created_at': 'Created At',

    'team-member-benefit.label.from__updated_at': 'From updated at',
    'team-member-benefit.label.to__updated_at': 'To updated at',
    'team-member-benefit.label.updated_at': 'Updated At',

    'team-member-benefit.label.from__deleted_at': 'From deleted at',
    'team-member-benefit.label.to__deleted_at': 'To deleted at',
    'team-member-benefit.label.deleted_at': 'Deleted At',

    'team-member-benefit.label.status': 'Status',

    'team-member-benefit.sort.field_label': 'Field',
    'team-member-benefit.sort.direction_label': 'Direction',
    'team-member-benefit.sort.direction_ascending': 'Ascending',
    'team-member-benefit.sort.direction_descending': 'Descending',

    'team-member-benefit.modal.title.team_member_benefit_archive': 'Archive Benefit',
    'team-member-benefit.modal.title.team_member_benefit_delete_permanently': 'Delete Benefit',
    'team-member-benefit.modal.title.team_member_benefit_restore': 'Restore Benefit',

    'team-member-benefit.modal.message.team_member_benefit_archive': 'Are you sure that you want to move this benefit to the archive? | Are you sure that you want to move these benefits to the archive?',
    'team-member-benefit.modal.message.team_member_benefit_delete_permanently':
        'Are you sure that you want to permanently delete this benefit? This action cannot be undone. | Are you sure that you want to permanently delete these benefits? This action cannot be undone.',
    'team-member-benefit.modal.message.team_member_benefit_restore': 'Are you sure that you want to restore this benefit? | Are you sure that you want to restore these benefits?',

    'team-member-benefit.success.message.team_member_benefit_created': 'Your benefit has been created',
    'team-member-benefit.success.message.team_member_benefit_updated': 'Your benefit has been updated',
    'team-member-benefit.success.message.team_member_benefit_restored': 'Your benefit has been restored | All selected benefits were restored',
    'team-member-benefit.success.message.team_member_benefit_deleted': 'Your benefit has been permanently deleted | All selected benefits were permanently deleted',
    'team-member-benefit.success.message.archived_team_member_benefits': 'Your benefit was moved to the archive | All selected benefits were moved to the archive',

    'team-member-benefit.error.message.archived_team_member_benefits': 'This benefit was already moved to the archive | These benefits were already moved to the archive',
    'team-member-benefit.error.message.team_member_benefit_deleted': 'This benefit was already permanently deleted | These benefits were already permanently deleted',
    'team-member-benefit.error.message.team_member_benefit_restored': 'This benefit was already restored | These benefits were already restored',
    'team-member-benefit.error.message.error_loading_page': 'Sorry, there was an error loading benefit.| Sorry, there was an error loading benefits.',

    'team-member-benefit.message.search.no_archived_team_member_benefits': "You haven't archived any team any member any benefits as yet.",
};
